// Payouts — shared formatting and API paths.
//
// Every rupee figure on these screens arrives as integer PAISE from
// billing-service (DOCTRINE §10: the money plane's own unit) and is
// formatted here, once — no screen does arithmetic beyond display sums.
// The API is the iot-admin thin proxy (/api/revenue/admin/* →
// billing.galigali.in /api/billing/revenue/*): billing-service stays the one
// writer; these screens are a reader with buttons.

export const inr = (paise, dp = 2) => (paise == null ? '—'
  : `₹${(Number(paise) / 100).toLocaleString('en-IN', { minimumFractionDigits: dp, maximumFractionDigits: dp })}`);

export const pct = (bps) => (bps == null ? '—' : `${(Number(bps) / 100).toLocaleString('en-IN')}%`);

export const shortId = (uuid) => (uuid ? String(uuid).slice(0, 8) : '—');

export const fmtDay = (d) => (d ? String(d).slice(0, 10) : '—');

export const monthLabel = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`)
  .toLocaleString('en-IN', { month: 'long', year: 'numeric' }) : '—');

// One vocabulary for the machine's verdicts, everywhere on these screens.
// open | paid | void (V360/V361). draft and confirmed are retired states kept
// here so a row written before the deploy still renders with a tone rather
// than an undefined one.
export const STATUS_TONE = {
  open: 'pend', draft: 'pend', confirmed: 'iris', paid: 'grow', void: 'bad',
};

export const ROLE_LABEL = {
  premise_operator: 'Premise operator',
  device_owner: 'Device owner',
  partner_commission: 'Partner commission',
  platform_tech: 'Technical fees',
  platform_margin: 'pDOOH margin',
  residual: 'Residual',
};

export const BASE = '/revenue/admin';

// A 200 that isn't the expected payload (an HTML fallthrough from a stale
// server, a proxy misroute) must become a readable ErrorState, never a
// TypeError mid-render. Every payout fetcher passes its response through
// this with the top-level key it is about to dereference.
export const shaped = (data, key) => {
  if (!data || typeof data !== 'object' || Array.isArray(data) || !(key in data)) {
    throw new Error(
      'The server did not answer with the revenue API payload. If this is a local dev '
      + 'session, the iot-admin server is probably older than the client — restart it '
      + '(Ctrl+C, then ./scripts/dev-iot-admin.sh).');
  }
  return data;
};
